import React, { useState, useRef, useMemo } from "react";
import { twMerge } from "tailwind-merge";
import { Tag } from "./utilityComps.jsx";
import { useMetaMaskContext } from "../wrappers/MetaMaskWrapper.jsx";
import { useAppContext } from "../App.jsx";
import { useAuthContext } from "../wrappers/AuthWrapper.jsx";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faBank,
  faBoxOpen,
  faChevronLeft,
  faCircle,
  faCoins,
  faFlag,
  faGear,
  faPen,
  faQuestionCircle,
  faSignOut,
  faSwatchbook,
  faSync,
  faTrash,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "framer-motion";
import { getv, nils } from "../utils/utils.jsx";
import { Mo, MoVariants } from "../utils/motion_helper.jsx";
import {
  AccountBalanceTag,
  useAccountContext,
} from "../wrappers/AccountWrapper.jsx";
import Login from "../views/Login.jsx";
import {
  ThridWebLoginSection,
  useThirdWebLoginContext,
} from "../views/ThirdWebLogin.jsx";
import { AutoConnect } from "thirdweb/react";
import { List } from "lucide-react";
// export const logoimg = "https://i.imgur.com/ngmPy1x.png";
export const logoimg = "https://cdn.dnaracing.run/imgs/dna_logo.png";

const portal = "https://www.dnaracing.run";

export const clearSiteData = async () => {
  // Clear localStorage
  let savedkeys = [
    "jwt_auth_token",
    "jwt_auth_account",
    "jwt_auth_aumode",
    "jwt_auth_auth",
  ];
  let save = savedkeys.map((k) => [k, localStorage.getItem(k)]);
  localStorage.clear();

  for (let [k, v] of save) {
    if (!nils(v)) localStorage.setItem(k, v);
  }

  // Clear cookies
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });

  // Clear IndexedDB (example for a database named 'myDatabase')
  const req = indexedDB.deleteDatabase("gltfCache");
  req.onsuccess = function () {
    console.log("Deleted database successfully");
  };
  req.onerror = function () {
    console.log("Couldn't delete database");
  };
  req.onblocked = function () {
    console.log("Couldn't delete database due to the operation being blocked");
  };

  setTimeout(() => {
    window.location.reload();
  }, 3000);
};

export const Logo = ({ title = "", title2 = "" }) => {
  return (
    <div className="fr-cc">
      <div className="xs:w-[8rem] lg:w-[15rem] aspect-[1879/504]  xs:ml-1 lg:ml-4 resp-p-2">
        <img className="h-full object-contain" src={logoimg} alt="" />
      </div>
    </div>
  );
};

const NavLogo = () => {
  const aucon = useAuthContext();

  const getLogoRedirectPath = () => {
    return "/";
  };

  return (
    <div className="layout-navlogo">
      <Link to={getLogoRedirectPath()}>
        <Logo />
      </Link>
    </div>
  );
};
const SM_VaultInfoCard = ({ whole_logout }) => {
  const aucon = useAuthContext();
  const { vault } = aucon;

  return (
    <div className="w-full max-w-[90vw] px-4">
      <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-r2lig/30 to-r2dark/50 backdrop-blur-xl border border-acc0/20 shadow-lg">
        {/* Background decoration */}
        <div className="absolute inset-0 bg-gradient-to-br from-acc0/5 to-transparent"></div>

        <div className="relative p-4">
          <div className="flex items-center space-x-4">
            {/* Avatar */}
            <div className="relative">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-acc0/20 to-acc1/20 flex items-center justify-center border border-acc0/30">
                <FontAwesomeIcon className="text-acc0 text-lg" icon={faUser} />
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-r2dark"></div>
            </div>

            {/* User info */}
            <div className="flex-1 min-w-0">
              <h3 className="font-digi text-sm font-medium text-acc0 break-words">
                {getv(aucon, "vaultdoc.vault_name") || "Vault User"}
              </h3>
              {/* <p className="text-xs text-r2lig/70 mt-1">
                Active Session
              </p> */}
            </div>

            {/* Action buttons */}
            <div className="flex space-x-2">
              <button
                onClick={clearSiteData}
                className="p-2 rounded-lg bg-orange-500/10 border border-orange-500/20 hover:bg-orange-500/20 transition-all duration-200 active:scale-95"
              >
                <FontAwesomeIcon
                  icon={faTrash}
                  className="text-orange-400 text-sm"
                />
              </button>
              <button
                onClick={whole_logout}
                className="p-2 rounded-lg bg-red-500/10 border border-red-500/20 hover:bg-red-500/20 transition-all duration-200 active:scale-95"
              >
                <FontAwesomeIcon
                  icon={faSignOut}
                  className="text-red-400 text-sm"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SM_LoginCard = () => {
  const aucon = useAuthContext();
  const tcon = useThirdWebLoginContext();
  const { aumode } = aucon;
  const show_t3login = !(aumode == "wallet" && aucon.auth == true);

  return (
    <div className="w-full max-w-[90vw] px-4 mb-6">
      <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-r2lig/30 to-r2dark/50 backdrop-blur-xl border border-acc0/20 shadow-lg">
        {/* Background decoration */}
        <div className="absolute inset-0 bg-gradient-to-br from-acc0/5 to-transparent"></div>

        <div className="relative p-4">
          <div className="flex flex-col items-center space-y-4">
            {/* Login Icon */}
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-acc0/20 to-acc1/20 flex items-center justify-center border border-acc0/30">
              <FontAwesomeIcon className="text-acc0 text-lg" icon={faUser} />
            </div>

            {/* Login Text */}
            <div className="text-center">
              <h3 className="font-digi text-sm font-medium text-acc0 mb-1">
                Connect Your Wallet
              </h3>
              <p className="text-xs text-r2lig/70">
                Login to access your vault
              </p>
            </div>

            {/* Action buttons */}
            <div className="flex flex-col space-y-2 w-full">
              {aucon.auth !== true && aumode === "thirdweb" && (
                <button
                  onClick={() => {
                    tcon.on_connect_fn(tcon.active_wallet);
                  }}
                  className="w-full p-3 rounded-lg bg-orange-500/10 border border-orange-500/20 hover:bg-orange-500/20 transition-all duration-200 active:scale-95"
                >
                  <div className="flex items-center justify-center space-x-2">
                    <FontAwesomeIcon
                      icon={faSync}
                      className="text-orange-400 text-sm"
                    />
                    <span className="text-orange-400 text-sm font-digi">
                      Retry Connection
                    </span>
                  </div>
                </button>
              )}

              {show_t3login && (
                <div className="w-max mx-auto">
                  <ThridWebLoginSection
                    btntext="Login"
                    postlogin={async () => {
                      await aucon.auth_refresh();
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AccountDrop = ({ options, size = "lg" }) => {
  const aucon = useAuthContext();
  const { vault } = aucon;

  const vault_name = getv(aucon, "vaultdoc.vault_name");

  const [hover, set_hover] = useState(false);

  const linkcn = "text-white hover:text-acc0 resp-py-1 resp-px-2 resp-text-1";

  return (
    <div
      className="cursor-pointer"
      {...{
        ...(size == "lg" ? { onMouseLeave: () => set_hover(false) } : {}),
        ...(size == "xs" ? { onClick: () => set_hover(!hover) } : {}),
      }}
    >
      <div
        {...{
          ...(size == "lg" ? { onMouseEnter: () => set_hover(true) } : {}),
          ...(size == "xs" ? {} : {}),
        }}
        className="fr-cc resp-mx-4 resp-gap-1 relative"
      >
        <div className="xs:w-[1.5rem] xs:h-[1.5rem] lg:w-[3rem] lg:h-[3rem] bg-dark fc-cc rounded-full">
          <FontAwesomeIcon className="text-acc0 resp-text-1" icon={faUser} />
        </div>
      </div>
      <motion.div
        variants={MoVariants.show_hide}
        animate={hover ? "visible" : "hidden"}
        className="absolute min-w-[15rem] w-[15rem] bg-r2dark/80 backdrop-blur-md m-1 border border-acc4 top-[3rem] right-0 rounded-md resp-p-4 z-30"
      >
        <p className="font-digi text-acc0 resp-py-1 resp-px-2 mb-2 resp-text-1">
          {vault_name}
        </p>
        <hr />
        <div className="xs:h-[60vh] lg:h-auto overflow-auto">
          {options.map(([to, txt, cn, fn, ico], index) => {
            return (
              <div key={index} className="w-full resp-py-2">
                <Link
                  onClick={() => {
                    if (fn) fn();
                  }}
                  to={to}
                  className={twMerge(cn, "fr-sc resp-gap-2")}
                >
                  <FontAwesomeIcon className="w-[1rem]" icon={ico} />
                  <span>{txt}</span>
                </Link>
              </div>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
};

const linkcn = "hover:text-acc0 font-mon resp-px-2 resp-text-0 fr-sc h-full";
const smlinkcn = "hover:text-acc0 font-digi resp-px-2 resp-text-2";

const SM_DropLink = ({ txt, links, set_smshow }) => {
  const dropcn = `smdroplink-${txt}`;
  const [show, set_show] = useState(false);

  return (
    <div className={twMerge(dropcn, "w-max h-full cursor-pointer relative")}>
      <div
        onClick={() => {
          set_show(!show);
        }}
        className={twMerge(smlinkcn, "fr-cc resp-gap-1")}
      >
        <span>{txt}</span>
        <FontAwesomeIcon
          className={twMerge(smlinkcn, show ? "rotate-180" : "")}
          icon={faAngleDown}
        />
      </div>
      <motion.div
        variants={MoVariants.show_hide}
        className=""
        animate={show ? "visible" : "hidden"}
      >
        <div className="fc-cc resp-p-1 resp-gap-1 rounded-lg bg-r2lig/20 backdrop-blur-md">
          {links.map(([to, txt, cn, fn, ico], li) => {
            return (
              <div key={li} className="w-full  resp-py-2">
                <Link
                  onClick={() => {
                    set_smshow(false);
                  }}
                  to={to}
                  className={twMerge(
                    `link-${li}`,
                    cn,
                    smlinkcn,
                    "fr-sc resp-gap-2",
                  )}
                >
                  <FontAwesomeIcon className="w-[1rem]" icon={ico} />
                  <span>{txt}</span>
                </Link>
              </div>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
};

const DropLink = ({ txt, links }) => {
  const dropcn = `droplink-${txt}`;
  const dropref = useRef(null);

  const [hover, set_hover] = useState(false);
  const history = useNavigate();

  const linkcn = "hover:text-acc4 font-mon resp-px-2 resp-text-0 fr-sc h-full";
  return (
    <div
      ref={dropref}
      onMouseLeave={() => {
        set_hover(false);
      }}
      className={twMerge(dropcn, "w-max h-full cursor-pointer relative")}
    >
      <div
        onMouseEnter={() => {
          set_hover(true);
        }}
        onClick={() => {
          let url = links[0][0];
          history(url);
        }}
        className={twMerge("main-link", linkcn, "fr-sc resp-gap-1")}
      >
        <span className="resp-text-0 font-reg">{txt}</span>
        <FontAwesomeIcon
          className={twMerge(
            "text-slate-600 resp-text--1 transition duration-300",
            hover ? "rotate-180" : "",
          )}
          icon={faAngleDown}
        />
      </div>
      <motion.div
        variants={MoVariants.show_hide}
        animate={hover ? "visible" : "hidden"}
        className="absolute min-w-[15rem] w-[15rem] bg-r2lig/40 backdrop-blur-md top-[3rem] left-0 rounded-md z-30"
      >
        <div className="border border-acc0 rounded-md p-[0.2rem]">
          <div className="resp-p-4 ">
            {links.map(([to, txt, cn, fn, ico], index) => {
              return (
                <div key={to} className="w-full resp-py-2">
                  <Link
                    onClick={() => {
                      if (fn) fn();
                      set_hover(false);
                    }}
                    to={to}
                    className={twMerge(cn, "fr-sc resp-gap-2")}
                  >
                    <FontAwesomeIcon className="w-[1rem]" icon={ico} />
                    <span>{txt}</span>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

const Nav = ({ loginpop, set_loginpop }) => {
  const { path } = useAppContext();
  const mmcon = useMetaMaskContext();
  const aucon = useAuthContext();
  const accon = useAccountContext();
  const tcon = useThirdWebLoginContext();

  const { aumode, auth } = aucon;
  const { vault } = accon;

  const activecn = "border-b border-acc0 text-acc0";

  const droplinks = [
    ["Assets", [[`/mint_v2`, "Core Mint", linkcn, null, faBoxOpen]]],
    [
      "Skins",
      [
        [`/skins`, "Skins", linkcn, null, faSwatchbook],
        ["/legacy-skins", "Old Skins", linkcn, null, faSwatchbook],
        // [`/skinmint`, "Mint Skins", linkcn, null, faSwatchbook],
        // [`/skingame`, "Skin Game", linkcn, null, faSwatchbook],
      ],
    ],
    [
      "More Info",
      [
        [`/moreinfo`, "More Info", linkcn, null, faQuestionCircle],
        [`/gameloop`, "Game Loop", linkcn, null, faCircle],
        [`/tokenomics`, "Tokenomics", linkcn, null, faCoins],
        [`/funds`, "Funds", linkcn, null, faBank],
      ],
    ],
  ];

  const links = [
    [`/tutorial`, "Tutorial", linkcn, null, faQuestionCircle],
    [`https://fbike.dnaracing.run/races`, "Lobby", linkcn, null, faFlag],
    [`https://market.dnaracing.run/`, "Market", linkcn, null, faCircle],
  ];

  const whole_logout = async () => {
    await tcon.logout();
    await aucon.logout();
  };

  const options = useMemo(
    () => [
      [
        null,
        "clear cache",
        twMerge(linkcn, "text-orange-300"),
        clearSiteData,
        faTrash,
      ],
      [
        null,
        "Logout",
        twMerge(linkcn, "text-red-300"),
        whole_logout,
        faSignOut,
      ],
    ],
    [whole_logout],
  );

  const noauth_links = [];

  const [smshow, set_smshow] = useState(false);
  const [submenu, set_submenu] = useState({ show: false, data: null });
  const show_t3login = !(aumode == "wallet" && auth == true);
  const cnmap = {
    activebtn:
      "text-[#2a9fff] border-2 border-[#2a9fff] bg-[#121D45]/80 shadow-[0_0_12px_rgba(42,159,255,0.4)] rounded-md transition-all",
  };

  const sm_menu_links = (() => {
    let ar = [];
    if (auth) {
      // Add dropdown links with appropriate icons for categories
      const dropdownIcons = {
        Assets: faBoxOpen,
        Skins: faSwatchbook,
        "More Info": faQuestionCircle,
      };

      droplinks.forEach(([txt, links]) => {
        ar.push({
          type: "dropdown",
          text: txt,
          icon: dropdownIcons[txt] || faCircle,
          links: links,
        });
      });

      // Add main links with icons
      links.forEach(([to, txt, cn, fn, ico]) => {
        ar.push({
          type: "link",
          to: to,
          text: txt,
          target: to && to.startsWith("/") ? "_self" : "_blank",
          icon: ico,
        });
      });

      // Add account options (excluding last 2 which are clear cache and logout)
      options.slice(0, -2).forEach(([to, txt, cn, fn, ico]) => {
        ar.push({
          type: "link",
          to: to,
          text: txt,
          className: cn,
          onClick: fn,
          icon: ico,
        });
      });
    } else {
      // Add links for non-authenticated users with icons
      noauth_links.forEach(([to, txt, cn, fn, ico]) => {
        ar.push({
          type: "link",
          to: to,
          text: txt,
          target: to && to.startsWith("/") ? "_self" : "_blank",
          icon: ico,
        });
      });
    }
    return ar;
  })();

  return (
    <>
      <div className="large-screen xs:hidden lg:block">
        <div className="bg-pagebg/50 h-[3.2rem] fr-sc">
          <NavLogo />
          <div className="flex-1"></div>
          <>
            <div className="w-[6rem]"></div>
            {droplinks.map(([txt, links]) => {
              return <DropLink key={txt} txt={txt} links={links} />;
            })}
            {links.map(([to, txt, cn, fn, ico]) => {
              let target = to && to.startsWith("/") ? "_self" : "_blank";
              return (
                <Link
                  key={to}
                  to={to}
                  target={target}
                  className={twMerge(linkcn, path == to ? activecn : "")}
                >
                  <span className="resp-text-0">{txt}</span>
                </Link>
              );
            })}
          </>
          <div className="flex-1"></div>

          {aucon.auth !== true && (
            <>
              <Tag
                onClick={() => {
                  tcon.on_connect_fn(tcon.active_wallet);
                }}
                className={twMerge(
                  "fr-sc resp-gap-1 bg-orange-400/20 text-orange-500",
                )}
              >
                <FontAwesomeIcon icon={faSync} className="" />
                <div className="resp-text--1">Retry</div>
              </Tag>
            </>
          )}

          {aucon.auth === true && (
            <>
              <AccountBalanceTag />
            </>
          )}

          {show_t3login && (
            <ThridWebLoginSection
              btntext="Login"
              postlogin={async () => {
                await aucon.auth_refresh();
              }}
            />
          )}

          <AutoConnect client={tcon.thirdweb_client} wallets={tcon.wallets} />

          {aucon.auth ? (
            <>
              <div className="w-[1rem]"></div>
              <AccountDrop options={options} />
            </>
          ) : (
            <>
              {false && (
                <div
                  onClick={() => {
                    set_loginpop(true);
                  }}
                  className=" cursor-pointer  mx-2 rounded-full bg-acc1 font-mon px-4 py-2"
                >
                  Login
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div className="small-screen xs:block lg:hidden">
        <div className="bg-pagebg/50 h-[3.2rem] fr-sc resp-gap-1 resp-px-2">
          <SM_MenuLayout
            show={smshow}
            set_show={set_smshow}
            trigger={
              <div
                className={twMerge(
                  "w-[3rem] h-[3rem] flex items-center justify-center rounded-xl transition-all duration-300 hover:scale-105 active:scale-95",
                  "bg-gradient-to-br from-r2lig/20 to-r2dark/30 backdrop-blur-sm border border-acc4/20 hover:border-acc0/40",
                  "shadow-lg hover:shadow-xl",
                )}
              >
                <List className="w-5 h-5 text-acc0" />
              </div>
            }
          >
            <AnimatePresence mode="wait">
              {submenu.show ? (
                <SM_SubMenuLayout
                  key="submenu"
                  submenu={submenu}
                  set_submenu={set_submenu}
                  set_smshow={set_smshow}
                />
              ) : (
                <motion.div
                  key="mainmenu"
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 50 }}
                  transition={{ duration: 0.3 }}
                  className="fc-cc resp-gap-1 resp-text-2"
                >
                  <div className="h-[2rem]"></div>
                  {aucon.auth ? (
                    <>
                      <SM_VaultInfoCard whole_logout={whole_logout} />
                      <div className=" mb-6"></div>
                    </>
                  ) : (
                    <SM_LoginCard />
                  )}

                  {/* Grid Layout for Navigation */}
                  <div className="w-full max-w-[90vw] px-4">
                    <div className="grid grid-cols-3 gap-3">
                      {sm_menu_links.map((item, index) => {
                        if (item.type === "dropdown") {
                          // For dropdown items, open submenu
                          return (
                            <motion.div
                              key={index}
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{
                                delay: index * 0.05,
                                duration: 0.3,
                              }}
                            >
                              <button
                                onClick={() =>
                                  set_submenu({ show: true, data: item })
                                }
                                className="group relative overflow-hidden rounded-xl bg-gradient-to-br from-r2lig/20 to-r2dark/30 backdrop-blur-sm border border-acc4/20 hover:border-acc0/40 transition-all duration-300 active:scale-95 min-h-[90px] block w-full"
                              >
                                {/* Background glow effect */}
                                <div className="absolute inset-0 bg-gradient-to-br from-acc0/0 group-hover:from-acc0/5 to-transparent transition-all duration-300"></div>

                                {/* Content */}
                                <div className="relative flex flex-col items-center justify-center p-4 h-full">
                                  <div className="mb-3 relative">
                                    <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-acc0/20 to-acc1/20 flex items-center justify-center border border-acc0/30 group-hover:scale-110 transition-transform duration-300">
                                      <FontAwesomeIcon
                                        icon={item.icon}
                                        className="text-acc0 text-sm group-hover:text-white transition-colors duration-300"
                                      />
                                    </div>
                                    {/* Subtle pulse animation */}
                                    <div className="absolute inset-0 rounded-lg bg-acc0/20 opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300"></div>
                                  </div>
                                  <span className="text-xs text-center font-digi text-r2lig group-hover:text-acc0 leading-tight transition-colors duration-300 font-medium">
                                    {item.text}
                                  </span>
                                </div>
                              </button>
                            </motion.div>
                          );
                        } else {
                          // Regular links
                          return (
                            <motion.div
                              key={index}
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{
                                delay: index * 0.05,
                                duration: 0.3,
                              }}
                            >
                              <Link
                                to={item.to}
                                target={item.target}
                                onClick={() => {
                                  if (item.onClick) item.onClick();
                                  set_smshow(false);
                                }}
                                className="group relative overflow-hidden rounded-xl bg-gradient-to-br from-r2lig/20 to-r2dark/30 backdrop-blur-sm border border-acc4/20 hover:border-acc0/40 transition-all duration-300 active:scale-95 min-h-[90px] block"
                              >
                                {/* Background glow effect */}
                                <div className="absolute inset-0 bg-gradient-to-br from-acc0/0 group-hover:from-acc0/5 to-transparent transition-all duration-300"></div>

                                {/* Content */}
                                <div className="relative flex flex-col items-center justify-center p-4 h-full">
                                  <div className="mb-3 relative">
                                    <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-acc0/20 to-acc1/20 flex items-center justify-center border border-acc0/30 group-hover:scale-110 transition-transform duration-300">
                                      <FontAwesomeIcon
                                        icon={item.icon}
                                        className="text-acc0 text-sm group-hover:text-white transition-colors duration-300"
                                      />
                                    </div>
                                    {/* Subtle pulse animation */}
                                    <div className="absolute inset-0 rounded-lg bg-acc0/20 opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300"></div>
                                  </div>
                                  <span className="text-xs text-center font-digi text-r2lig group-hover:text-acc0 leading-tight transition-colors duration-300 font-medium">
                                    {item.text}
                                  </span>
                                </div>
                              </Link>
                            </motion.div>
                          );
                        }
                      })}
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
            <div className="h-[8rem]"> </div>
          </SM_MenuLayout>
          <NavLogo />
          <div className="flex-1"></div>

          {aucon.auth !== true && aumode === "thirdweb" && (
            <>
              <Tag
                onClick={() => {
                  tcon.on_connect_fn(tcon.active_wallet);
                }}
                className={twMerge(
                  "fr-sc resp-gap-1 bg-orange-400/20 text-orange-500",
                )}
              >
                <FontAwesomeIcon icon={faSync} className="" />
                <div className="resp-text--1">Retry</div>
              </Tag>
            </>
          )}

          <div className="scale-[0.5] max-w-[6rem] transform translate-x-[-2rem]">
            {show_t3login && (
              <ThridWebLoginSection
                btntext="Login"
                postlogin={async () => {
                  await aucon.auth_refresh();
                }}
              />
            )}
          </div>
          {aucon.auth ? (
            <>
              <AccountBalanceTag />
            </>
          ) : (
            <>
              {false && (
                <div
                  onClick={() => {
                    set_loginpop(true);
                  }}
                  className=" cursor-pointer mx-2 rounded-full bg-acc1 font-mon px-3 py-1"
                >
                  Login
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

const LayoutContext = React.createContext();
export const useLayoutContext = () => React.useContext(LayoutContext);

const SM_SubMenuLayout = ({ submenu, set_submenu, set_smshow }) => {
  if (!submenu.show || !submenu.data) return null;

  const { text, links, icon } = submenu.data;

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.3 }}
      className="fc-cc resp-gap-1 resp-text-2"
    >
      <div className="h-[2rem]"></div>

      {/* Header with back button */}
      <div className="w-full max-w-[90vw] px-4 mb-6">
        <div className="flex items-center justify-between">
          <button
            onClick={() => set_submenu({ show: false, data: null })}
            className="group flex items-center gap-3 rounded-xl bg-gradient-to-br from-r2lig/20 to-r2dark/30 backdrop-blur-sm border border-acc4/20 hover:border-acc0/40 transition-all duration-300 active:scale-95 px-4 py-3"
          >
            <FontAwesomeIcon
              icon={faChevronLeft}
              className="text-acc0 group-hover:text-white transition-colors duration-300"
            />
            <span className="text-sm font-digi text-r2lig group-hover:text-acc0 transition-colors duration-300">
              Back
            </span>
          </button>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-acc0/20 to-acc1/20 flex items-center justify-center border border-acc0/30">
              <FontAwesomeIcon icon={icon} className="text-acc0 text-lg" />
            </div>
            <h2 className="text-xl font-digi text-acc0 font-medium">{text}</h2>
          </div>
          <div className="w-16"></div> {/* Spacer for centering */}
        </div>
      </div>

      {/* Submenu links grid */}
      <div className="w-full max-w-[90vw] px-4">
        <div className="grid grid-cols-2 gap-3">
          {links.map(([to, txt, cn, fn, ico], index) => {
            const isExternal = to && to.startsWith("http");

            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.3 }}
              >
                <Link
                  to={to}
                  target={isExternal ? "_blank" : "_self"}
                  onClick={() => {
                    if (fn) fn();
                    set_submenu({ show: false, data: null });
                    set_smshow(false);
                  }}
                  className="group relative overflow-hidden rounded-xl bg-gradient-to-br from-r2lig/20 to-r2dark/30 backdrop-blur-sm border border-acc4/20 hover:border-acc0/40 transition-all duration-300 active:scale-95 min-h-[100px] block"
                >
                  {/* Background glow effect */}
                  <div className="absolute inset-0 bg-gradient-to-br from-acc0/0 group-hover:from-acc0/5 to-transparent transition-all duration-300"></div>

                  {/* Content */}
                  <div className="relative flex flex-col items-center justify-center p-4 h-full">
                    <div className="mb-3 relative">
                      <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-acc0/20 to-acc1/20 flex items-center justify-center border border-acc0/30 group-hover:scale-110 transition-transform duration-300">
                        <FontAwesomeIcon
                          icon={ico}
                          className="text-acc0 text-lg group-hover:text-white transition-colors duration-300"
                        />
                      </div>
                      {/* Subtle pulse animation */}
                      <div className="absolute inset-0 rounded-lg bg-acc0/20 opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300"></div>
                    </div>
                    <span className="text-sm text-center font-digi text-r2lig group-hover:text-acc0 leading-tight transition-colors duration-300 font-medium">
                      {txt}
                    </span>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
};

const SM_MenuLayout = ({ trigger, show, set_show, ...props }) => {
  // const [show, set_show] = useState(true);
  const { auth } = useAuthContext();
  const { vault, vdoc } = useAccountContext();

  return (
    <>
      <div
        onClick={() => set_show(!show)}
        className={twMerge(twMerge("sm-nav-menu-trigger", "cursor-pointer"))}
      >
        {trigger}
      </div>
      <motion.div
        {...Mo.slide({ x: ["-100%", 0, "100%"] })}
        animate={show ? "visible" : "hidden"}
        transition={{ delay: show ? 0.1 : 0.25 }}
        className="z-[50] h-page fixed top-[3.5rem] left-0 w-full bg-r2dark"
      >
        <div className="h-full w-full bg-gradient-to-br from-pagebg/80 to-pagebg/60 backdrop-blur-xl">
          <div className="h-[100%] overflow-auto">{props.children}</div>
          {/* <SMCloseBtn closefn={() => set_show(false)} extcn="smclose-nav" /> */}
        </div>
      </motion.div>
    </>
  );
};

function Layout(props) {
  const appcon = useAppContext();
  const aucon = useAuthContext();

  const open_loginpop = () => aucon.open_loginpop();
  const laycon = {
    open_loginpop,
  };
  return (
    <div className="relative">
      <LayoutContext.Provider value={laycon}>
        <Nav />
        <main
          className={
            twMerge("relative box-border")
            // "md:max-w-[80rem] md:w-full mx-auto",
            // "xs:max-w-[95vw] mx-auto"
          }
        >
          <>{props.children}</>
        </main>
      </LayoutContext.Provider>
    </div>
  );
}

export default Layout;
